// extracted by mini-css-extract-plugin
module.exports = {"modalWindowContainer":"styles_modalWindowContainer__FTnFT","modalWindow":"styles_modalWindow__rd1WZ","show":"styles_show__FUbDq","cancelButton":"styles_cancelButton__dVb8a"};